// include team's acronyms in the description for easier search

import { CanaryStoreEntry } from '@bill/canary.react'
import { themeOptions } from '@divvy-web/skylab.themeprovider'

const canaryConfig: CanaryStoreEntry[] = [
  {
    name: 'theme',
    variants: ['default', ...themeOptions],
    metadata: {
      description: 'GOLD: The theme to use for the application',
      icon: '🎨',
    },
    value: 'default',
  },
  {
    description: 'when enabled, show maintenance screen',
    name: 'sputnik-maint-mode',
    value: false,
  },
  {
    description: 'when enabled, shows underwriting page redesign',
    name: 'rollout-uw-page-redesign',
    value: false,
  },
  {
    description: 'when enabled, enables advanced onboarding return flow logic',
    name: 'advanced-onboarding-return-flow',
    value: false,
  },
  {
    description: 'COM: when enabled, show credit app dashboard redesign',
    name: 'rollout-credit-app-dashboard-redesign',
    value: false,
  },
  {
    name: 'beep-credit-application-review-page-collapsed-experiment',
    variants: [
      {
        behaviorName: 'sectionsExpanded',
        control: true,
        placement: 'QUALIFIED',
      },
      {
        behaviorName: 'sectionsCollapsed',
        placement: 'QUALIFIED',
      },
      {
        placement: 'NOT_QUALIFIED',
      },
      {
        placement: 'EXPERIMENT_OFF',
      },
    ],
    metadata: {
      description: 'COM: beep experiment attempt to collapse sections on the review page',
    },
  },
  {
    name: 'rollout-invite-collaborators-redesign',
    value: false,
    metadata: {
      description: 'COM: rollout flag for the redesign of the invite collaborators drawer',
    },
  },
]

export default canaryConfig
